import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Sponsor = (): React.JSX.Element => {
    return (
        <div data-testid="sponsorContent">
            <Container className="py-5">
                <Row>
                    <Col>
                        <p>
                            By becoming an Official Sponsor of the MAJOR YBL you
                            will reach over 10,000 current and former MAJOR YBL
                            families with your brand message.
                        </p>
                        <p>
                            Help support youth baseball, while benefiting from
                            the opportunity exposure to these families offer. We
                            have teams throughout all of SE Wisconsin, providing
                            a great opportunity to promote your business.
                        </p>
                        <p>
                            Official Sponsors receive banner ads throughout our
                            sites, a Wisconsin Baseball Tournaments named after
                            them, several email blasts to our ever growing email
                            list of MAJOR YBL families and more. Don't delay,
                            contact us today as we do limit the number of
                            official sponsorships.
                        </p>
                        <p>
                            To contact us about our very affordable official
                            sponsorship program, please click&nbsp;
                            <a href="mailto:shawn@majorybl.com">HERE</a>
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Sponsor;
